// Service-message helpers shared by the broadcast page and the coupon admin's pre-expiry
// warning. They mirror backend/services/broadcast.py (SERVICE_TAG, MAX_TAG_LEN,
// MAX_MESSAGE_LEN, _normalize_message): a message opens with a tag line in square brackets,
// then a blank line, then the body. The broadcast page renders its preview on the server
// (POST /api/admin/broadcast/preview), so formatting is decided in one place.

export const DEFAULT_TAG = 'MESSAGGIO DI SERVIZIO';
export const SERVICE_PREFIX = `[${DEFAULT_TAG}]`;
export const MAX_TAG_LEN = 40;
export const MAX_LEN = 4000;

// The coupon warning always carries the default tag.
export function previewText(body) {
  const trimmed = (body || '').trim();
  if (!trimmed) return '';
  return trimmed.startsWith(SERVICE_PREFIX)
    ? trimmed
    : `${SERVICE_PREFIX}\n\n${trimmed}`;
}

// What the tag field keeps while typing: no brackets (the page draws them), one line.
export function cleanTagInput(value) {
  return (value || '').replace(/[[\]\r\n]/g, '').slice(0, MAX_TAG_LEN);
}

// A one-line summary of a markdown body, for a table cell.
export function plainSummary(markdown) {
  return (markdown || '')
    .replace(/\[([^\]\n]+)\]\([^)\s]+\)/g, '$1')
    .replace(/```[\w+-]*\n?/g, '')
    .replace(/^[ \t]*#{1,6}[ \t]+/gm, '')
    .replace(/\*\*|~~|`/g, '')
    .replace(/(^|[^\w*])\*(?=[^\s*])([^*\n]+?)\*(?![\w*])/g, '$1$2')
    .replace(/(^|[^\w])_(?=[^\s_])([^_\n]+?)_(?!\w)/g, '$1$2')
    .replace(/\s+/g, ' ')
    .trim();
}
